import React, { Component } from 'react'
import { TextArea } from '@driftt/tide-core'
import { defaultTo } from 'ramda'

class TextInput extends Component {
  constructor(props) {
    super(props)
    this.placeholder = `Add ${props.property.type.toLowerCase()} values separated by line breaks…`

    this.state = {
      currentValue: props.value || ''
    }
  }

  handleChange = ({target: { value }}) => {
    const { onChange, property } = this.props

    this.setState({
      currentValue: value
    })

    if (value === '') {
      return onChange(value)
    }

    let formattedValue = value.trim()
    switch (property.type) {
      case 'STRING':
        formattedValue = formattedValue.split(/\r?\n/)
        break
      case 'NUMERIC':
        formattedValue = formattedValue.split(/\r?\n/).map(v => defaultTo(v, +v))
        break
      default:
    }

    onChange(formattedValue)
  }

  render() {
    const { currentValue } = this.state

    return (
        <TextArea
          {...this.props}
          className="contact-details--typed-input--text"
          onChange={this.handleChange}
          value={currentValue}
          placeholder={this.placeholder}
          type="text"
        />
    )
  }
}

export default TextInput
